import { useNavigate } from "react-router-dom";
import AppLayout from "../../components/AppLayout/AppLayout";


const menuItems = [
  {
    id: 1,
    label: "Petty Cash Request",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="#7c3ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
        <path d="M6 15h4" />
      </svg>
    ),
    route: "/PettyCashRequest",
  },
  {
    id: 2,
    label: "Petty Cash Expense",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="#7c3ab5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
    route: "/PettyCashExpense",
  },
];


export default function PettyCashScreen() {
  const navigate = useNavigate();

  return (
    <AppLayout title="Petty Cash" onBack={() => navigate(-1)}>
      <div style={{ margin: 16, background: "#fff", borderRadius: 12, overflow: "hidden", border: "0.5px solid #e5e5e5" }}>
        {menuItems.map((item, index) => (
          <div key={item.id} onClick={() => navigate(item.route)}
            style={{ display: "flex", alignItems: "center", gap: 12, padding: 16, cursor: "pointer",
              borderBottom: index < menuItems.length - 1 ? "0.5px solid #eee" : "none" }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: "#eeedfe",
              display: "flex", alignItems: "center", justifyContent: "center" }}>
              {item.icon}
            </div>
            <span style={{ flex: 1, fontSize: 14, color: "#333" }}>{item.label}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}